import { useQuery } from '@tanstack/react-query';

import {
  PAGE_HOST_KIND,
  QUERY_KEY,
  TENANT_INFO_FALLBACK_TIMEOUT_MS,
  TENANT_INFO_TIMEOUT_MS,
} from '~common';
import { PAGE_HOST } from '~configs';
import { getAuthRequest } from '~services';
import { TenantInfo, TenantInfoResponse } from '~types';

export const useQueryGetTenantInfo = () => {
  const fetcher = async (): Promise<TenantInfo> => {
    const response: TenantInfoResponse = await getAuthRequest({
      path: 'api/v1/tenant-info',
      ignoreAuthHeader: true,
      config: {
        timeout:
          PAGE_HOST.kind === PAGE_HOST_KIND.TENANT
            ? TENANT_INFO_TIMEOUT_MS
            : TENANT_INFO_FALLBACK_TIMEOUT_MS,
      },
    });
    return response.data;
  };

  return useQuery([QUERY_KEY.GET_TENANT_INFO], fetcher, {
    enabled: PAGE_HOST.kind !== PAGE_HOST_KIND.UNKNOWN,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
